import $ from "jquery";
import React from 'react';
import Dialog from 'material-ui-next/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import Joi from 'joi';
import {
  withStyles
} from 'material-ui-next/styles';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';
import Fade from 'material-ui-next/transitions/Fade';
import turingLogo from '../../assets/svg/logo-vertical.svg';
import Input, {
  InputLabel
} from 'material-ui-next/Input';
import {
  FormControl,
  FormHelperText
} from 'material-ui-next/Form';

function Transition(props) {
  return <Fade {...props} />;
}

const colorMain = '#3ed5ad'

const styles = theme => ({
  dialog: {
    textAlign: 'center',
  },
  flex: {
    flex: 1
  },
  appBar: {
    position: 'relative'
  },
  card: {},
  media: {
    maxWidth: '60%',
    height: 150,
    marginBottom: 4 * theme.spacing.unit
  },
  content: {
    marginTop: '15%',
    marginLeft: '20%',
    width: '60%',
    textAlign: 'center',
  },
  button: {
    marginTop: 4 * theme.spacing.unit,
  },
  links: {
    marginTop: 4 * theme.spacing.unit,
    flex: 1
  },
  textField: {
    marginTop: 3 * theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      minWidth: 260,
    },
    maxWidth: 400,
    minWidth: '30%'
  },
  textRoot: {
    color: colorMain
  },
  textUnderline: {
    '&:before': {
      backgroundColor: colorMain,
      opacity: 0.42
    },
  },
  textInkbar: {
    '&:after': {
      backgroundColor: colorMain,
    },
  },
})

class LoginMainView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user_name: '',
      password: '',
      login_msg: null
    }

    this.validatorTypes = {
      user_name: Joi.string()
        .required()
        .min(2)
        .email()
        .label('Username'),
      password: Joi.string()
        .required()
        .label('Password')
    }

    this.getValidatorData = this.getValidatorData.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onEnterDown = this.onEnterDown.bind(this)
    this.onEnterInUsername = this.onEnterInUsername.bind(this)
  }

  handleChange(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleBlur(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    }, () => {
      this.props.handleValidation(name);
    });
  }

  onSubmit(e) {
    e.preventDefault()
    this.props.validate((err) => {
      if (err) return
      this.props.onLogin(this.state, (err) => {
        if (err) {
          this.setState({
            login_msg: err.message
          })
        }
      })
    })
  }

  onEnterDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.onSubmit(e)
    }
  }

  onEnterInUsername(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      $('#password').focus()
    }
  }

  renderHelperText(msg) {
    var err_msg = msg
    if (Array.isArray(msg) && msg.length > 0) {
      err_msg = msg[0]
    }
    return (
      <span>{err_msg}</span>
    )
  }

  getValidatorData() {
    return this.state
  }

  render() {
    const {
      classes
    } = this.props
    return (
      <div>
        <Dialog
          title="Turing Partner Portal Login"
          fullScreen
          open={true}
          transition={Transition}
          className={classes.dialog}
        >
          <div className={classes.content}>
            <p>{this.renderHelperText(this.state.login_msg)}</p>
            <img
              className={classes.media}
              src={turingLogo}
              alt="Turing Video Partner Portal"
            />
            <br />
            <FormControl className={classes.textField}>
              <InputLabel className={classes.textRoot}>Email</InputLabel>
              <Input
                name="user_name"
                value={this.state.user_name}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                onKeyDown={this.onEnterInUsername}
                classes={{
                  underline: classes.textUnderline,
                  inkbar: classes.textInkbar
                }}
              />
              <FormHelperText>
                {this.renderHelperText(this.props.getValidationMessages('user_name'))}
              </FormHelperText>
            </FormControl>
            <br />
            <FormControl className={classes.textField}>
              <InputLabel className={classes.textRoot}>Password</InputLabel>
              <Input
                name="password"
                type="password"
                id="password"
                value={this.state.password}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                onKeyDown={this.onEnterDown}
                classes={{
                  underline: classes.textUnderline,
                  inkbar: classes.textInkbar
                }}
              />
              <FormHelperText>
                {this.renderHelperText(this.props.getValidationMessages('password'))}
              </FormHelperText>
            </FormControl>
            <br/>
            <RaisedButton
              className={classes.button}
              backgroundColor="#3ed5ad"
              labelColor="#ffffff"
              label="Login"
              onClick={this.onSubmit}
              disabled={!this.props.isValid()}
            />
          </div>
        </Dialog>
      </div>
    )
  }
}

LoginMainView.defaultProps = {
  onLogin: null,
  from: {
    pathname: '/'
  }
}

export default withStyles(styles)(validation(strategy)(LoginMainView))



// WEBPACK FOOTER //
// ./src/views/login/main.react.js